<template>
  <div>
    <base-header class="pb-8 pt-4">
      <div class="row">
        <div class="col-sm-12 col-md-3">
          <b-form-group>
            <b-form-select
              v-model="filterType"
              :options="[
                { text: $t('Bu hafta'), value: 'weekly' },
                { text: $t('Bu ay'), value: 'monthly' },
                { text: $t('Tarih seç'), value: 'other' },
              ]"
            />
          </b-form-group>
        </div>
        <template v-if="filterType === 'other'">
          <div class="col-sm-12 col-md-2">
            <b-form-group class="mb-0">
              <b-form-input type="date" v-model="startDate" />
            </b-form-group>
          </div>
          <div class="col-sm-12 col-md-2">
            <b-form-group class="mb-0">
              <b-form-input type="date" v-model="endDate" />
            </b-form-group>
          </div>
        </template>
        <div class="col-sm-12 col-md-3">
          <b-button variant="primary" @click="loadData">{{
            $t('Güncelle')
          }}</b-button>
        </div>
      </div>
      <!-- Card stats -->
      <div class="row" v-if="user.homepage_permission">
        <div class="col-sm-12 col-md-3">
          <stats-card
            :title="$t('Gelir')"
            :sub-title="`${income} TL`"
            icon="fas fa-chart-bar text-white"
            class="mb-4 mb-xl-0 bg-gradient-info"
          >
          </stats-card>
        </div>
        <div class="col-sm-12 col-md-3">
          <stats-card
            :title="$t('Gider')"
            :sub-title="`${expense} TL`"
            icon="fas fa-chart-pie"
            class="mb-4 mb-xl-0 bg-gradient-danger"
          >
          </stats-card>
        </div>
        <div class="col-sm-12 col-md-3">
          <stats-card
            :title="$t('Kâr')"
            :sub-title="`${profit} TL`"
            icon="ni ni-diamond"
            class="mb-4 mb-xl-0 bg-gradient-green"
          >
          </stats-card>
        </div>
        <div class="col-sm-12 col-md-3">
          <stats-card
            :title="$t('Yeni İşlem Sayısı')"
            :sub-title="`${processCount}`"
            icon="ni ni-diamond"
            class="mb-4 mb-xl-0 bg-gradient-warning"
          >
          </stats-card>
        </div>
      </div>
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--7">
      <b-row v-if="loaded">
        <b-col>
          <b-card no-body class="homeCard">
            <b-card-header>
              <h3 class="mb-0">{{ $t('Bugünkü Randevular') }}</h3>
            </b-card-header>

            <b-table
              ref="table"
              class="align-items-center"
              thead-class="thead-light"
              :fields="[
                { key: 'id', label: $t('#') },

                { key: 'client_name', label: $t('Ad Soyad') },
                { key: 'employee.full_name', label: $t('Personel') },
                { key: 'client_gsm', label: $t('Telefon') },
                { key: 'start_time', label: $t('Saat') },
                { key: 'actions', label: '' },
              ]"
              :items="appointments"
              responsive
              show-empty
            >
              <template> </template>
              <template v-slot:empty>
                <b-alert variant="danger" show
                  >{{ $t('Bugün hiç prova yok') }}!</b-alert
                >
              </template>

              <template v-slot:cell(client_name)="data">
                {{
                  data.item.client
                    ? data.item.client.full_name
                    : 'Müşteri Silinmiş'
                }}
              </template>
              <template v-slot:cell(client_gsm)="data">
                {{
                  data.item.client ? data.item.client.gsm : 'Müşteri Silinmiş'
                }}
              </template>
              <template v-slot:cell(start_time)="data">
                {{ moment(data.item.start_time).format('HH:mm') }} -
                {{ moment(data.item.end_time).format('HH:mm') }}
              </template>
              <template v-slot:cell(actions)="data">
                <b-button
                  size="sm"
                  variant="primary"
                  @click="openReminderModal(data.item)"
                  >{{ $t('Hatırlat') }}</b-button
                >
              </template>
            </b-table>
          </b-card>
        </b-col>
        <b-col md="12" class="my-4" v-if="user.homepage_permission">
          <b-card no-body class="homeCard">
            <b-card-header>
              <h3 class="mb-0">{{ $t('Yaklaşan Borçlar') }}</h3>
            </b-card-header>

            <b-table
              ref="table"
              class="align-items-center"
              thead-class="thead-light"
              :fields="[
                { key: 'title', label: $t('Başlık') },
                { key: 'client.full_name', label: $t('Müşteri Adı') },
                { key: 'price', label: $t('Ücret') },
                { key: 'last_payment_date', label: $t('Son Ödeme') },
                { key: 'actions', label: '' },
              ]"
              :items="debts"
              responsive
              show-empty
            >
              <template v-slot:empty>
                <b-alert variant="success" show
                  >{{ $t('Hiç yaklaşan borcunuz yok') }}!</b-alert
                >
              </template>
              <template v-slot:cell(actions)="data">
                <b-button
                  size="sm"
                  variant="success"
                  @click="clearDebtAction(data.item.id)"
                  >{{ $t('Tamamla') }}</b-button
                >
              </template>
            </b-table>
          </b-card>
        </b-col>

        <div
          class="mt-3"
          style="width: 100%; border-bottom: 1px solid gray; padding: 25px 20px"
        >
          <div class="item-img"></div>
          <div class="" style="font-size: 17px">
            <span style="color: white; font-weight: bold">
              {{ $t('BUGÜN:') }}
            </span>
            <span style="color: #86ac29; font-weight: bold">
              {{ today }}
            </span>
          </div>
        </div>
      </b-row>
      <!-- End charts-->
      <div class="w-100 text-center" v-else>
        <b-spinner variant="primary" />
      </div>
    </div>

    <!-- Debt to Expense -->
    <change-accounting-type
      :show="showChangeModal"
      :id="dateModal.id"
      to="expense"
      @hide="resetChangeModal"
      @refresh-table="loadData"
    />
    <!--#Debt to Expense -->

    <b-modal title="Randevu Hatırlat" ref="reminderModal">
      <b-form-group>
        <label>Mesaj</label>
        <b-form-textarea rows="5" v-model="reminder.text" />
      </b-form-group>

      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="$refs.reminderModal.hide()">{{
          $t('Kapat')
        }}</b-button>
        <b-button variant="primary" @click="remindAppointment">{{
          $t('SMS Gönder')
        }}</b-button>
      </template>
    </b-modal>

    <div class="pr-6 pl-6 pb-3">
      <div class="daily-report-container">
        <!-- <div class="dr-item sending">
          <div class="item-img"><img src="/pro/dc-sending.svg" /></div>
          <div class="result">
            <span>{{ $t('TESLİMAT') }}</span>
            <span>{{ deliveryLeasesCount }}</span>
            <b> {{ $t('ÜRÜN') }}</b>
          </div>
        </div> -->
        <div class="dr-item sended">
          <div class="item-img"><img src="/pro/dc-sended.svg" /></div>
          <div class="result">
            <span>{{ $t('RANDEVU') }}</span>
            <span>{{ appointments.length }}</span>
            <b> {{ $t('MÜŞTERİ') }}</b>
          </div>
        </div>

        <!-- <div class="dr-item error">
          <div class="item-img"><img src="/pro/kuru-temizleme.png" /></div>
          <div class="result">
            <span>{{ $t('KURU TEMİZLEME') }}</span>
            <span>{{ dryCount }}</span>
            <b>{{ $t('ÜRÜN') }}</b>
          </div>
        </div> -->
        <!-- <div class="dr-item recipient">
          <div class="item-img"><img src="/pro/dc-recipient.png" /></div>
          <div class="result">
            <span>{{ $t('TERZİ') }}</span>
            <span>{{ tailorCount }}</span>
            <b>{{ $t('ÜRÜN') }}</b>
          </div>
        </div> -->
        <div class="dr-item spent">
          <div class="item-img"><img src="/pro/dc-spent.svg" /></div>
          <div class="result">
            <span>{{ $t('KREDİ') }}</span>
            {{ smsBalance }}
            <b>{{ $t('Kredi') }}</b>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ChangeAccountingType from '../components/modal/ChangeAccountingType';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import moment from 'moment';

export default {
  components: { ChangeAccountingType },
  computed: {
    ...mapGetters[('user', 'smsBalance')],
    today() {
      moment.locale('TR');
      return moment().format('LLLL');
    },
  },
  data() {
    return {
      tailorCount: 0,
      dryCount: 0,
      fields: [
        { key: 'client.full_name', label: 'Müşteri Adı' },
        { key: 'client.phone', label: 'Telefonu' },
        { key: 'service.name', label: 'Ürün Adı' },
      ],
      loaded: false,
      filterType: 'weekly',
      startDate: '',
      endDate: '',
      income: '',
      expense: '',
      profit: '',
      processCount: '',
      smsBalance: 0,
      appointments: [],
      debts: [],
      user: {},
      deliveryLeasesCount: 0,
      dateModal: {},
      activeLeasesCount: 0,
      showChangeModal: false,
      reminder: {
        id: '',
        text: '',
      },
    };
  },
  methods: {
    ...mapActions([
      'dashboard',
      'appointmentReminder',
      'getUser',
      'getLeasedProducts',
      'getDashboard',
    ]),
    ...mapMutations(['setSMSBalance']),
    getDash() {
      return this.getDashboard();
    },
    issueLeases() {
      return this.getLeasedProducts('todayissue')
        .then((data) => data.data)
        .then((response) => {
          this.deliveryLeasesCount = response.length;
          return response;
        });
    },
    deliveryLeases() {
      return this.getLeasedProducts('todaydelivery')
        .then((data) => data.data)
        .then((response) => {
          return response;
        });
    },
    remindAppointment() {
      this.appointmentReminder(this.reminder)
        .then((response) => {
          this.success(response.data.message);
          this.setSMSBalance(response.data.balance);
          this.$refs.reminderModal.hide();
        })
        .catch((error) => {
          this.error(error.response.data.message);
        });
    },
    openReminderModal(client) {
      this.reminder = {
        id: client.id,
        text: `Sayın ${client.client.full_name}, ${this.moment(
          client.start_date
        ).format('DD.MM.YY')} tarihli; saat ${this.moment(
          client.start_date
        ).format('HH:mm')} randevunuzu hatırlatırız.`,
      };
      this.$refs.reminderModal.show();
    },
    moment(d) {
      return moment(d);
    },
    clearDebtAction(id) {
      this.dateModal.id = id;
      this.showChangeModal = true;
    },
    resetChangeModal() {
      this.dateModal.id = '';
      this.showChangeModal = false;
    },
    async loadData() {
      this.loaded = false;
      await this.getDash().then((response) => {
        this.dryCount = response.data.dry_count;
        this.tailorCount = response.data.tailor_count;
      });
      // await this.getLeasedProducts('now')
      //     .then(data => data.data).then(response => {
      //       this.activeLeasesCount = response.length
      //       return response;
      //     })
      await this.getUser().then((res) => (this.user = res));
      const parameters = this.parameters();
      this.dashboard(parameters)
        .then((data) => data.data)
        .then((response) => {
          // summary cards
          this.income = response.income;
          this.expense = response.expense;
          this.profit = response.profit;
          this.processCount = response.process_count;
          this.setSMSBalance(response.sms_balance);
          this.smsBalance = response.sms_balance;
          this.appointments = response.appointments;
          this.debts = response.debts;

          // show charts
          this.loaded = true;
        });
    },
    parameters() {
      const params = {};
      params.type = this.filterType;
      if (this.filterType === 'other') {
        params.start_date = this.startDate;
        params.end_date = this.endDate;
      }
      return params;
    },
  },

  async mounted() {
    await this.loadData();
  },
};
</script>
<style data-tippy-stylesheet="">
.tippy-box[data-animation='fade'][data-state='hidden'] {
  opacity: 0;
}

[data-tippy-root] {
  max-width: calc(100vw - 10px);
}

.tippy-box {
  position: relative;
  background-color: #333;
  color: #fff;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1.4;
  outline: 0;
  transition-property: transform, visibility, opacity;
}

body {
  background-attachment: fixed;
}

.tippy-box[data-placement^='top'] > .tippy-arrow {
  bottom: 0;
}

.tippy-box[data-placement^='top'] > .tippy-arrow:before {
  bottom: -7px;
  left: 0;
  border-width: 8px 8px 0;
  border-top-color: initial;
  transform-origin: center top;
}

.tippy-box[data-placement^='bottom'] > .tippy-arrow {
  top: 0;
}

.tippy-box[data-placement^='bottom'] > .tippy-arrow:before {
  top: -7px;
  left: 0;
  border-width: 0 8px 8px;
  border-bottom-color: initial;
  transform-origin: center bottom;
}

.tippy-box[data-placement^='left'] > .tippy-arrow {
  right: 0;
}

.tippy-box[data-placement^='left'] > .tippy-arrow:before {
  border-width: 8px 0 8px 8px;
  border-left-color: initial;
  right: -7px;
  transform-origin: center left;
}

.tippy-box[data-placement^='right'] > .tippy-arrow {
  left: 0;
}

.tippy-box[data-placement^='right'] > .tippy-arrow:before {
  left: -7px;
  border-width: 8px 8px 8px 0;
  border-right-color: initial;
  transform-origin: center right;
}

.tippy-box[data-inertia][data-state='visible'] {
  transition-timing-function: cubic-bezier(0.54, 1.5, 0.38, 1.11);
}

.tippy-arrow {
  width: 16px;
  height: 16px;
  color: #333;
}

.tippy-arrow:before {
  content: '';
  position: absolute;
  border-color: transparent;
  border-style: solid;
}
.homeCard {
  height: 550px;
  overflow-y: auto;
  -webkit-overflow-scrolling: revert;
}
.tippy-content {
  position: relative;
  padding: 5px 9px;
  z-index: 1;
}
</style>